import {Injectable} from '@angular/core';
import {RestServiceAbstract} from "../../base/rest.service.abstract";
import {OrderRequest} from '../api/order.request.model';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root',
})

export class OrderRestService extends RestServiceAbstract {

    public createOrder(request: OrderRequest): Observable<any> {
        console.log("createOrderRest: " + request);
        return this.post(`/${this.RESOURCE}/order/order`, request).pipe(
            map(data => {
                console.log(data);
                return data;
            })
        );
    }

}
